import React from 'react'
import qaCallout from './qa-callout'

const doc = {
  title: 'Q&A: Batt Insulation Pattern',
  slug: 'qa-batt-insulation-pattern',
  tags: ['forum', 'q&a', 'question', 'answer'],
  category: 'q-and-a',
  content: (props) => {
    return <div>
      {qaCallout}
      <p>
        <a href="https://forums.autodesk.com/t5/revit-architecture-forum/batt-insulation-pattern/m-p/9162546#M261503" target="_blank" rel="noreferrer">Read more of this thread on forums.autodesk.com</a>
      </p>
      <blockquote className="doc-blockquote doc-blockquote-user">
        <strong className="doc-blockquote-title">Asked by <a href="https://forums.autodesk.com/t5/user/viewprofilepage/user-id/5154106" target="_blank" rel="noreferrer">@ChrisGamble</a> on 11/22/2019 on the Revit Architecture Forum:</strong><br/>
        How can I get a batt insulation pattern? I need to show batt insulation in my walls and It would be nice to apply it to a material and not have to draw it separately. Is this possible?
      </blockquote>
      
      <blockquote className="doc-blockquote">
        <strong className="doc-blockquote-title"><a href="https://forums.autodesk.com/t5/user/viewprofilepage/user-id/6702606" target="_blank" rel="noreferrer">@Pattycake_Kyle</a> on 7/19/2020:</strong><br/>
        This comes up in our office a couple times a year. I recommend you use the insulation tool Revit has built in to it. The main downside tho is that it can't be part of components (R2018 & earlier, haven't tested 2019).
        <br/><br/>
        Our office developed a detail component insulation piece that is parametric for the different widths (i think there is a similar one floating around on revit city), so it at least can be made into a component and then used easier without needing to be a group. The other option just using groups with the normal insulation tool but then you end up with tons of groups. And I also think the detail component is a bit 'heavy' for the model but *shrug*. Its kinda lose/lose.
        <br/><br/>
        If you do want to go the PAT route, we have 2 part of our free library at the moment, here for example: <a href="https://pattycake.io/official/pat/8GQbRO7wW7b" target="_blank">https://pattycake.io/official/pat/8GQbRO7wW7b</a>
        <br/><br/>
        I wouldn't go the PAT route tho (and why we only really have 2 sizes in our library) since any material you assign it to will only work well in that specific view scale (being a drafting pattern). And you'd have to do some heavy filtering to get it to show up correctly elsewhere. You could make it a model pattern and test that out I suppose, but you probably will end up with some sort of alignment issues there. If you do that, please let me know how it goes - i'd be interested to hear.
      </blockquote> 

    </div>
  }
}

export default doc;


// WEBPACK FOOTER //
// ./src/docs/qa-batt-insulation-pattern.js